function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
export const parseQueryParams = (query)=>{
    const q = query.startsWith('?') ? query.substring(1) : query;
    const parts = q.split('&');
    return parts.reduce((acc, part)=>{
        const [k, v] = part.split('=');
        if (!k) return acc;
        const key = decodeURIComponent(k);
        const value = decodeURIComponent(v !== null && v !== void 0 ? v : '');
        if (key.endsWith('[]')) {
            const finalKey = key.slice(0, key.length - 2);
            const prevValue = acc[finalKey];
            const finalValue = [
                ...Array.isArray(prevValue) ? prevValue : [],
                value
            ];
            return _object_spread_props(_object_spread({}, acc), {
                [finalKey]: finalValue
            });
        }
        return _object_spread_props(_object_spread({}, acc), {
            [key]: value
        });
    }, {});
};

//# sourceMappingURL=parseQueryParams.js.map